<template>
    <div class="card widget-calendar m-3">
        <div class="p-3 pb-0 card-header">
            <h6 class="mb-0">Reservaciones</h6>
            <div class="d-flex">
                <div class="mb-0 text-sm p font-weight-bold widget-calendar-day">
                    <!-- Puedes agregar información adicional aquí -->
                </div>
                <div class="mb-1 text-sm p font-weight-bold widget-calendar-year">
                    <!-- Puedes agregar información adicional aquí -->
                </div>
            </div>
            <!-- Menús de filtrado -->
            <div class="d-flex flex-wrap justify-content-between mt-3">
                <div class="flex-fill me-2 mb-2 w-30">
                    <MenuSelectedPatient
v-model="filters.patient_id" label="Filtrar por Paciente"
                        :can-edit-and-add="false" />
                </div>
                <div class="flex-fill me-2 mb-2">
                    <MenuSelectedFull
v-model="filters.doctor_id" label="Filtrar por Médico" apiurl="users-doctors"
                        :can-edit-and-add="false" />
                </div>
                <div class="flex-fill me-2 mb-2">
                    <MenuSelectedFull
v-model="filters.center_id" label="Filtrar por Centro" apiurl="center-medicals"
                        :can-edit-and-add="false" />
                </div>
                <div class="flex-fill mb-2">
                    <MenuSelectedFull
v-model="filters.status" :label="'Filtrar por Estado'" :category="'status'"
                        :can-edit-and-add="false" :local-data="stateNames" />
                </div>
                <div class="flex-fill d-flex align-items-end justify-content-end mb-2 mt-4 m-2">
                    <button type="button" class="btn btn-secondary mt-2" @click="clearFilters">Limpiar Filtros</button>
                </div>
            </div>
        </div>
        <div class="p-3 card-body">
            <div class="d-flex justify-content-between">
                <div class="calendar-container">
                    <div id="reservation-calendar"></div>
                </div>
                <div v-show="isDayView" class="mini-calendar-container">
                    <div id="mini-calendar"></div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="showModal" class="modal-backdrop animated-backdrop">
        <div class="modal-dialog-centered modal-animated">
            <div class="modal-content">
                <div class="modal-header bg-gradient-primary">
                    <h5 class="modal-title text-white">{{ isEditing ? 'Editar Evento' : 'Crear Evento' }}</h5>
                    <button type="button" class="btn-close" @click="closeModal"></button>
                </div>
                <div class="tabs-container">
                    <div class="tabs-header">
                        <button
:class="{ active: activeTab === 'eventos' }"
                            @click="changeTab('eventos')">Evento</button>
                        <button
:class="{ active: activeTab === 'detalles' }"
                            @click="changeTab('detalles')">Detalles</button>
                    </div>

                    <!-- 🟢 Formulario ENCERRANDO ambas pestañas -->
                    <form @submit.prevent="saveEvent">
                        <div class="tabs-body">
                            <!-- Contenido de la pestaña 'eventos' -->
                            <div v-if="activeTab === 'eventos'">
                                <div class="modal-body">
                                    <div class="col-12">
                                        <MenuSelectedPatient
v-model="eventForm.patient_id" label="Paciente"
                                            :can-edit-and-add="true" />
                                    </div>
                                    <div class="col-12">
                                        <MenuSelectedFull
v-model="eventForm.doctor_id" label="Médico"
                                            apiurl="users-doctors" :can-edit-and-add="false" />
                                        <div v-if="errors.doctor_id" class="invalid-feedback">{{ errors.doctor_id[0] }}
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <MenuSelectedFull
v-model="eventForm.center_id" label="Centro"
                                            apiurl="center-medicals" :can-edit-and-add="false" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="title" class="form-label">Motivo</label>
                                        <input
id="title" v-model="eventForm.title" type="text" class="form-control"
                                            :class="{ 'is-invalid': errors.title }">
                                        <div v-if="errors.title" class="invalid-feedback">{{ errors.title[0] }}</div>
                                    </div>
                                    <div class="d-flex mb-3">
                                        <div class="me-3">
                                            <label class="form-label">Fecha y Hora de Inicio</label>
                                            <DatePickerTime
v-model="eventForm.start" :errors="errors"
                                                error-field-name="start" :is-all-day="eventForm.allDay" />
                                            <div v-if="errors.start_date" class="invalid-feedback">{{
                                                errors.start_date[0] }}</div>
                                        </div>
                                        <div>
                                            <label class="form-label">Fecha y Hora de Fin</label>
                                            <TimeIntervalPopup
:start-time="eventForm.start" :default-interval="30"
                                                @interval-selected="addIntervalToEnd" />
                                            <DatePickerTime
v-model="eventForm.end" :errors="errors"
                                                error-field-name="end" :is-all-day="eventForm.allDay" />
                                            <div v-if="errors.end_date" class="invalid-feedback">{{ errors.end_date[0]
                                            }}</div>
                                        </div>
                                        <div class="me-3">
                                            <label class="form-label">Todo el día</label>
                                            <argon-switch
id="eventAllDay" class="d-flex justify-content-end mt-1"
                                                :checked="eventForm.allDay" name="Remember Me"
                                                @change="eventForm.allDay = $event.target.checked">
                                            </argon-switch>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Contenido de la pestaña 'detalles' -->
                            <div v-if="activeTab === 'detalles'">
                                <div class="col-12 text-center">
                                    <div class="form-group">
                                        <div
class="btn-group btn-group-toggle btn-group-colors event-tag"
                                            data-toggle="buttons">
                                            <label
class="btn bg-gradient-info position-relative"
                                                :class="{ active: eventForm.className === 'bg-gradient-info' }"
                                                @click="eventForm.className = 'bg-gradient-info'">
                                                <span
v-if="eventForm.className === 'bg-gradient-info'"
                                                    class="position-absolute top-50 start-50 translate-middle">
                                                    <i class="fa-solid fa-circle-check"></i>
                                                </span>
                                            </label>
                                            <label
class="btn bg-gradient-warning position-relative"
                                                :class="{ active: eventForm.className === 'bg-gradient-warning' }"
                                                @click="eventForm.className = 'bg-gradient-warning'">
                                                <span
v-if="eventForm.className === 'bg-gradient-warning'"
                                                    class="position-absolute top-50 start-50 translate-middle">
                                                    <i class="fa-solid fa-circle-check"></i>
                                                </span>
                                            </label>
                                            <label
class="btn bg-gradient-danger position-relative"
                                                :class="{ active: eventForm.className === 'bg-gradient-danger' }"
                                                @click="eventForm.className = 'bg-gradient-danger'">
                                                <span
v-if="eventForm.className === 'bg-gradient-danger'"
                                                    class="position-absolute top-50 start-50 translate-middle">
                                                    <i class="fa-solid fa-circle-check"></i>
                                                </span>
                                            </label>
                                            <label
class="btn bg-gradient-success position-relative"
                                                :class="{ active: eventForm.className === 'bg-gradient-success' }"
                                                @click="eventForm.className = 'bg-gradient-success'">
                                                <span
v-if="eventForm.className === 'bg-gradient-success'"
                                                    class="position-absolute top-50 start-50 translate-middle">
                                                    <i class="fa-solid fa-circle-check"></i>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="phone" class="form-label">Teléfono</label>
                                        <input id="phone" v-model="eventForm.phone" type="text" class="form-control">
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="email" class="form-label">Correo Electrónico</label>
                                        <input id="email" v-model="eventForm.email" type="email" class="form-control">
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <MenuSelectedFull
v-model="eventForm.status" :label="'Estado'" :category="'status'"
                                        :can-edit-and-add="false" :local-data="stateNames" />
                                    <div v-if="errors.status" class="invalid-feedback">
                                        {{ errors.status[0] }}
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="eventComments" class="form-label">Comentarios</label>
                                    <textarea
id="eventComments" v-model="eventForm.comments"
                                        class="form-control"></textarea>
                                </div>
                            </div>
                        </div>

                        <!-- 🟢 Botones dentro del form para asegurar el envío -->
                        <div class="modal-footer">
                            <button type="button" class="btn btn-light" @click="closeModal">Cancelar</button>
                            <button type="submit" class="btn btn-primary">
                                {{ isEditing ? 'Guardar Cambios' : 'Crear Evento' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>


</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick, reactive, watch } from 'vue';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es';
import DatePickerTime from '@/components/DatePickerTime.vue';
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import TimeIntervalPopup from '@/components/TimeIntervalPopup.vue';
import MenuSelectedPatient from '@/components/MenuSelectedPatient.vue';
import MenuSelectedFull from "@/components/MenuSelectedFull.vue";
import { stateNames } from '@/data/menuvalues';

import api from '@/services/api';
import Swal from 'sweetalert2';

let calendar;
let miniCalendar;

const events = ref([]);
const showModal = ref(false);
const isEditing = ref(false);
const isDayView = ref(false);

const eventForm = ref({
    id: null,
    title: '',
    start: '',
    end: '',
    comments: '',
    allDay: false,
    className: 'bg-gradient-success',
    patient_id: null,
    center_id: null,
    doctor_id: null,
    phone: '',
    email: '',
    status: '1'
});

const filters = reactive({
    patient_id: null,
    doctor_id: null,
    center_id: null,
    status: ''
});

const clearFilters = () => {
    filters.patient_id = null;
    filters.doctor_id = null;
    filters.center_id = null;
    filters.status = '';

    setTimeout(() => {
        filters.patient_id = null;
        filters.doctor_id = null;
        filters.center_id = null;
        filters.status = '';
    }, 10);
};

const errors = ref({});
const activeTab = ref("eventos");

const changeTab = (tab) => {
    activeTab.value = tab;
};

const fetchReservations = async () => {
    try {
        const response = await api.get('/appointments', { params: filters });
        const data = response.data;

        if (data && data.events) {
            events.value = data.events.map(event => ({
                id: event.id,
                title: event.title,
                start: new Date(event.start),
                end: new Date(event.end),
                className: event.extendedProps.className,
                center_id: event.extendedProps.center_id,
                doctor_id: event.extendedProps.doctor_id,
                phone: event.extendedProps.phone,
                email: event.extendedProps.email,
                status: event.extendedProps.status,
                allDay: event.allDay,
                extendedProps: event.extendedProps
            }));

            if (calendar) {
                calendar.removeAllEvents();
                events.value.forEach(event => {
                    calendar.addEvent(event);
                });
            }
        } else {
            console.error("Unexpected response structure:", data);
        }
    } catch (error) {
        console.error("Error fetching reservations:", error);
    }
};

watch(filters, () => {
    fetchReservations();
}, { deep: true });

const openModal = (event = null, selectedDate = null) => {
    if (event) {
        isEditing.value = true;
        errors.value = {};
        eventForm.value = {
            id: event.id,
            title: event.title,
            start: formatDateToLocal(event.start),
            end: formatDateToLocal(event.end),
            comments: event.extendedProps.comments,
            allDay: event.allDay,
            className: event.extendedProps.className,
            patient_id: event.extendedProps.patient_id,
            center_id: event.extendedProps.center_id,
            doctor_id: event.extendedProps.doctor_id,
            phone: event.extendedProps.phone,
            email: event.extendedProps.email,
            status: event.extendedProps.status
        };
    } else {
        isEditing.value = false;
        const startDate = selectedDate ? formatDateToLocal(selectedDate) : '';
        const endDate = selectedDate ? formatDateToLocal(new Date(new Date(selectedDate).getTime() + 30 * 60000)) : ''; // 30 minutos después de la fecha de inicio
        eventForm.value = {
            id: null,
            title: '',
            start: startDate,
            end: endDate,
            comments: '',
            allDay: false,
            className: 'bg-gradient-success',
            patient_id: null,
            center_id: null,
            doctor_id: null,
            phone: '',
            email: '',
            status: '1'
        };
    }
    showModal.value = true;
};

const formatDateToLocal = (isoDate) => {
    if (!isoDate) return '';

    const localDate = new Date(isoDate);
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    const seconds = '00';
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const formatDateToServer = (date, isAllDay = false) => {
    if (!date) return '';

    const localDate = new Date(date);
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');

    if (isAllDay) {
        return {
            start: `${year}-${month}-${day} 00:00:00`,
            end: `${year}-${month}-${day} 23:59:59`,
        };
    }

    // Manejar eventos con horas
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    const seconds = '00';

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const saveEvent = async () => {
    try {
        if (!eventForm.value.start || !eventForm.value.end) {
            throw new Error("La fecha y hora de inicio y fin son obligatorias.");
        }

        const event = {
            start_date: formatDateToServer(eventForm.value.start),
            end_date: formatDateToServer(eventForm.value.end),
            title: eventForm.value.title,
            comments: eventForm.value.comments,
            all_day: eventForm.value.allDay,
            className: eventForm.value.className,
            patient_id: eventForm.value.patient_id,
            center_id: eventForm.value.center_id,
            doctor_id: eventForm.value.doctor_id,
            phone: eventForm.value.phone,
            email: eventForm.value.email,
            status: eventForm.value.status
        };

        const response = eventForm.value.id
            ? await api.put(`/appointments/${eventForm.value.id}`, event)
            : await api.post('/appointments', event);

        const savedEvent = response.data.data;

        if (eventForm.value.id) {
            const index = events.value.findIndex((e) => e.id === eventForm.value.id);
            if (index !== -1) {
                events.value[index] = { ...savedEvent, className: "bg-gradient-success" };
            }
            const calendarEvent = calendar.getEventById(eventForm.value.id);
            if (calendarEvent) {
                calendarEvent.setProp('title', savedEvent.title);
                calendarEvent.setStart(savedEvent.start_date);
                calendarEvent.setEnd(savedEvent.end_date);
                calendarEvent.setAllDay(savedEvent.all_day);
                calendarEvent.setExtendedProp('comments', savedEvent.comments);
                calendarEvent.setProp('className', eventForm.value.className);
            }
        } else {
            events.value.push({ ...savedEvent, className: "bg-gradient-success" });
            calendar.addEvent({
                id: savedEvent.id,
                title: savedEvent.title,
                start: savedEvent.start_date,
                end: savedEvent.end_date,
                allDay: savedEvent.all_day,
                className: eventForm.value.className,
                extendedProps: {
                    comments: savedEvent.comments,
                },
            });
        }

        Swal.fire("Éxito", response.data.message, "success");
        fetchReservations();
        showModal.value = false;
        errors.value = {};
    } catch (error) {
        if (error.response && error.response.status === 422) {
            errors.value = { ...error.response.data.errors };
        } else {
            Swal.fire("Error", error.message, "error");
        }
    }
};

const closeModal = () => {
    showModal.value = false;
    errors.value = {};
};

const updateEvent = async (event) => {
    let formattedStart, formattedEnd;

    if (event.allDay) {
        const formattedDates = formatDateToServer(event.start, true);
        formattedStart = formattedDates.start;
        formattedEnd = formattedDates.end;
    } else {
        formattedStart = formatDateToServer(event.start);
        formattedEnd = formatDateToServer(event.end || event.start); // Si no hay `end`, usar `start`
    }

    try {
        const updatedEvent = {
            start_date: formattedStart,
            end_date: formattedEnd,
            title: event.title,
            comments: event.extendedProps?.comments || '',
            className: event.extendedProps?.className || '',
            all_day: event.allDay,
        };

        const response = await api.put(`/appointments/${event.id}`, updatedEvent);
        const savedEvent = response.data.data;

        const index = events.value.findIndex((e) => e.id === event.id);
        if (index !== -1) {
            events.value[index] = { ...savedEvent, className: "bg-gradient-success" };
        }

        Swal.fire("Éxito", response.data.message, "success");
    } catch (error) {
        if (error.response && error.response.status === 422) {
            errors.value = error.response.data.errors || {};
        } else {
            Swal.fire("Error", error.message, "error");
        }
    }
};

onMounted(() => {
    fetchReservations().then(() => {
        calendar = new Calendar(document.getElementById('reservation-calendar'), {
            plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
            initialView: 'timeGridWeek',
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
            },
            locale: esLocale,
            slotMinTime: '07:00:00',
            slotMaxTime: '24:00:00',
            events: events.value,
            editable: true,
            slotLabelFormat: {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            },
            eventTimeFormat: {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            },
            eventClick: (info) => {
                openModal(info.event);
            },
            dateClick: (info) => {
                openModal(null, info.date);
            },
            eventDrop: (info) => {
                updateEvent(info.event);
            },
            eventResize: (info) => {
                updateEvent(info.event);
            },
            datesSet: (info) => {
                isDayView.value = info.view.type === 'timeGridDay';

                if (isDayView.value) {
                    renderMiniCalendar();
                } else {
                    if (miniCalendar) {
                        miniCalendar.destroy();
                        miniCalendar = null;
                    }
                    setTimeout(() => {
                        calendar.render();
                    }, 50);
                }
            },
            viewWillUnmount: (view) => {
                if (view.view.type === 'timeGridDay') {
                    isDayView.value = false;
                    if (miniCalendar) {
                        miniCalendar.destroy();
                    }
                }
            }
        });

        calendar.render();
    });
});

const renderMiniCalendar = async () => {
    await nextTick();

    const miniCalendarEl = document.getElementById('mini-calendar');
    if (!miniCalendarEl) return;

    if (miniCalendar) return;

    miniCalendar = new Calendar(miniCalendarEl, {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        selectable: true,
        locale: 'es',
        headerToolbar: {
            left: '',
            center: 'title',
            right: 'prev,next'
        },
        dateClick: (info) => {
            document.querySelectorAll('.fc-daygrid-day').forEach(day => {
                day.classList.remove('fc-day-selected');
            });

            const selectedDay = document.querySelector(`[data-date="${info.dateStr}"]`);
            if (selectedDay) selectedDay.classList.add('fc-day-selected');

            calendar.changeView('timeGridDay', info.dateStr);
        }
    });

    miniCalendar.render();
};

onBeforeUnmount(() => {
    if (calendar) {
        calendar.destroy();
    }
});

const addIntervalToEnd = (interval) => {
    if (eventForm.value.start) {
        const startDate = new Date(eventForm.value.start);
        startDate.setMinutes(startDate.getMinutes() + interval);
        eventForm.value.end = formatDateToLocal(startDate.toISOString());
    }
};
</script>

<style scoped>
.modal-body {
    padding: 0px !important;
}

.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    display: block;
    color: #dc3545;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1040;
}

.modal-dialog-centered {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1050;
    width: 90%;
    max-width: 500px;
}

.modal-animated {
    animation: fadeIn 0.3s;
}

.d-flex {
    display: flex;
}

.justify-content-end {
    justify-content: flex-end;
}

.calendar-container {
    flex-grow: 1;
    min-width: 600px;
    min-height: 500px;
    overflow: hidden;
}

.datepicker-container {
    flex-shrink: 0;
    width: 250px;
    /* Ajusta según sea necesario */
}

.mini-calendar-container {
    flex-shrink: 0;
    width: 320px;
    height: 450px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 10px;
    border: 1px solid #ddd;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    overflow: hidden;
    /* Evita el scroll */
}

#mini-calendar {
    width: 100%;
    height: 100%;
}

.fc-daygrid-day {
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
}

/* Efecto hover en los días */
.fc-daygrid-day:hover {
    background-color: rgba(0, 123, 255, 0.1);
    transform: scale(1.05);
}

/* Estilo para el día actual */
.fc-day-today {
    background-color: rgba(0, 123, 255, 0.2) !important;
    border-radius: 50%;
}

/* Estilo para el día seleccionado */
.fc-day-selected {
    background-color: rgba(0, 123, 255, 1) !important;
    color: white !important;
    font-weight: bold;
    border-radius: 50%;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Estilos para los botones de los tabs */
.tabs-container {
    overflow: hidden;
}

.tabs-header {
    display: flex;
    justify-content: space-between;
    background-color: #f8f9fa;
    padding: 10px;
}

.tabs-header button {
    flex: 1;
    padding: 10px;
    border: none;
    background: none;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.tabs-header button:hover {
    background-color: #e9ecef;
}

.tabs-header button.active {
    background-color: #007bff;
    color: white;
    font-weight: bold;
    border-radius: 5px;
}

.tabs-body {
    padding: 15px;
    background: white;
}
</style>
